import type { SkyscannerMichelinSearchV1Search } from '@skyscanner-internal/michelin-web-http-client';

type SearchRequestHotelFilter = SkyscannerMichelinSearchV1Search.SearchRequestHotelFilter;

export const mapHotelFilterToApiFormat = (filterId: string): SearchRequestHotelFilter => {
  if (!filterId) {
    return 'HOTEL_FILTER_UNSPECIFIED';
  }

  const filterMap: Record<string, SearchRequestHotelFilter> = {
    common_best_v1: 'HOTEL_FILTER_COMMON_BEST',
    cr_cheap_v1: 'HOTEL_FILTER_CHEAP',
    cr_excellent_v1: 'HOTEL_FILTER_EXCELLENT',
    cr_4star_v1: 'HOTEL_FILTER_4STAR',
    cr_free_cancellation_v1: 'HOTEL_FILTER_FREE_CANCELLATION',
    cr_free_breakfast_v1: 'HOTEL_FILTER_FREE_BREAKFAST',
  } as const;

  return filterMap[filterId] || 'HOTEL_FILTER_UNSPECIFIED';
};

export const mapApiFormatToHotelFilter = (hotelFilter: string): string => {
  if (!hotelFilter || hotelFilter === 'HOTEL_FILTER_UNSPECIFIED') {
    return 'common_best_v1';
  }

  const reverseFilterMap: Record<string, string> = {
    HOTEL_FILTER_COMMON_BEST: 'common_best_v1',
    HOTEL_FILTER_CHEAP: 'cr_cheap_v1',
    HOTEL_FILTER_EXCELLENT: 'cr_excellent_v1',
    HOTEL_FILTER_4STAR: 'cr_4star_v1',
    HOTEL_FILTER_FREE_CANCELLATION: 'cr_free_cancellation_v1',
    HOTEL_FILTER_FREE_BREAKFAST: 'cr_free_breakfast_v1',
    HOTEL_FILTER_UNSPECIFIED: 'common_best_v1',
  };

  return reverseFilterMap[hotelFilter] || 'common_best_v1';
};
